export const Roles = {
  EightWings: "eightwings",
  Admin: "admin",
  RbhUser: "rbhuser",
  GeneralUser: "generaluser",
  Customer: "customer",
};
